import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "swiper/css";
import "swiper/css/navigation";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/offerbanner.css";
import { gettopoffer } from "../service/topoffer.service";

const OfferBanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadOffers();
  }, []);

  const loadOffers = async () => {
    try {
      setLoading(true);
      const response = await gettopoffer();
      // console.log("Top Offers:", response);

      setBanners(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
    if (!loading && OfferBanner?.length) return null;

  return (
    <section className="offersbanner">
      <div className="container">
        <div className="banner-slider position-relative">
          <div className="swiper-button-prev custom-nav"></div>
          <div className="swiper-button-next custom-nav"></div>

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop
          >
            {loading ? (
              <SwiperSlide>
                <Skeleton height={400} />
              </SwiperSlide>
            ) : (
              banners.map((banner) => {
                const image =
                  banner.media.find(
                    (item) => item.deviceType === "desktop"
                  ) || banner.media[0];

                return (
                  <SwiperSlide key={banner.id}>
                    <Link to="/productListsecand">
                      <img
                        src={image?.image}
                        alt={image?.altText}
                        className="img-fluid w-100"
                      />
                    </Link>
                  </SwiperSlide>
                );
              })
            )}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default OfferBanner;